import Content from "./Content.jsx";
import Footer from "./Footer.jsx";
import Stepper from "./Stepper.jsx";
import styles from "./Page.module.css";
import { FLOW_STEPS } from "../../constants/flow.js";
import { useOccurrence } from "../../context/OccurrenceContext.jsx";

// A etapa "Troca" só aparece quando o cliente escolheu trocar.
function stepsFor(resolutionType) {
  if (!resolutionType || resolutionType === "exchange") return FLOW_STEPS;
  return FLOW_STEPS.filter((item) => item.id !== "exchange");
}

/**
 * Layout das telas do portal.
 * - Computador: largura total (até --page-max) e, se houver `aside`, duas colunas
 *   (conteúdo + resumo fixo à direita).
 * - Celular: uma coluna; o `aside` vem depois do conteúdo (resumo + botão de ação no fim).
 * `narrow` centraliza formulários curtos.
 */
const Page = ({
  children,
  title,
  subtitle,
  step,
  onBack,
  backLabel = "Voltar",
  aside,
  narrow = false,
}) => {
  const { resolutionType } = useOccurrence();
  return (
    <div className={styles.shell}>
      {(onBack || title || step) ? (
        <header className={styles.top}>
          <div className={styles.heading}>
            {onBack ? (
              <button type="button" className={styles.back} onClick={onBack}>
                ← {backLabel}
              </button>
            ) : null}
            {title ? <h1 className={styles.title}>{title}</h1> : null}
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>
          {step ? <div className={styles.stepper}><Stepper current={step} steps={stepsFor(resolutionType)} /></div> : null}
        </header>
      ) : null}
      <Content>
        <div className={`${styles.layout} ${aside ? styles.withAside : ""} ${narrow && !aside ? styles.narrow : ""}`}>
          <div className={styles.main}>{children}</div>
          {aside ? <aside className={styles.aside}>{aside}</aside> : null}
        </div>
      </Content>
      <Footer />
    </div>
  );
};

export default Page;
